import { useCallback } from 'react'

import { ConfirmationModal, useModal } from '@procurify/ui'

import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useDisconnectSlackIntegrationModel } from '../../models/useDisconnectSlackIntegrationModel'

export const useDisconnectSlackIntegrationPresenter = () => {
  const modal = useModal()
  const intl = useProcurifyIntl()
  const { disconnect, isDisconnecting } = useDisconnectSlackIntegrationModel()

  const confirmDisconnect = useCallback(async () => {
    try {
      await disconnect()
      modal.hideModal()
      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage),
      })
    } catch {
      modal.hideModal()
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children: intl.formatMessage(messages.errorMessage),
      })
    }
  }, [disconnect, modal, intl])

  const handleDisconnect = useCallback(async () => {
    await modal.showModal(ConfirmationModal, {
      open: true,
      type: 'warning',
      header: intl.formatMessage(messages.confirmTitle),
      message: intl.formatMessage(messages.confirmMessage),
      confirmButtonText: intl.formatMessage(messages.confirmButton),
      handleDismiss: () => modal.hideModal(),
      onConfirm: confirmDisconnect,
    })
  }, [modal, intl, confirmDisconnect])

  return {
    commands: { handleDisconnect },
    states: { isDisconnecting },
  }
}
